import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Vue from "vue";
export default Vue.extend({
  name: "ShareManagementSource-list",
  props: {
    IsAll: {
      type: Boolean,
      default: false
    },
    schoolCourseId: {
      type: String,
      default: ""
    },
    courseId: {
      type: String,
      default: ""
    },
    userType: {
      type: [Number, String],
      default: 0
    },
    isShow: {
      type: Boolean,
      default: ""
    },
    importCourseVisible: {
      type: Boolean,
      default: ""
    }
  },
  created: function created() {
    this.$router.push({
      name: "teaShareDiscussCourse",
      params: {}
    });
  },
  data: function data() {
    return {
      iportCourseIds: [],
      interaction: [{
        word: "讨论",
        name: "teaShareDiscussCourse",
        type: "3"
      }, {
        word: "投票",
        name: "teaShareVoteCourse",
        type: "6"
      }, {
        word: "提问",
        name: "teaShareQuestion",
        type: "4"
      }, {
        word: "测验",
        name: "teaShareTest",
        type: "10"
      }, {
        word: "问卷调查",
        name: "teaShareSurveyCourse",
        type: "7"
      }, {
        word: "头脑风暴",
        name: "teaShareBrainstormingCourse",
        type: "2"
      }],
      icon: 0,
      checkList: []
    };
  },
  methods: {
    sureImport: function sureImport() {
      var that = this;

      if (this.IsAll = true) {
        that.sourceList_ = [];
      }

      this.$http.post("/api/partner/CourseSourceImport/importPrepare", {
        PrepareType: that.checkList,
        toCourseId: that.courseId,
        fromCourseIds: that.iportCourseIds
      }).then(function (rst) {
        if (rst.code > 0) {
          that.checkList = [];
          that.$message.success(rst.msg);
          that.importCourseVisible = false;
          that.getOff();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    getCourseIds: function getCourseIds(val) {
      var that = this;
      this.iportCourseIds = [];
      val.forEach(function (item) {
        that.iportCourseIds.push(item.Id);
      });
      console.log(that.iportCourseIds);
    },
    getOff: function getOff() {
      this.importCourseVisible = false;
      this.$emit("offOver", false);
      this.$refs.childCourse.clearSection();
    },
    hanldClick: function hanldClick(i, item) {
      this.icon = i;
      this.$router.push({
        name: item.name
      });
    },
    handleChecked: function handleChecked() {}
  }
});